<template>
    <router-link
        v-if="linkEnabled"
        :to="to"
        :class="resolvedLinkClass"
        v-bind="boundAttrs"
        v-on="$listeners"
    >
        <slot />
    </router-link>
    <span v-else :class="resolvedTextClass" v-bind="boundAttrs">
        <slot />
    </span>
</template>

<script>
import { canAccessNavigationRoute } from "@/utils/navigationPermissions";

export default {
    name: "ScopedRouteLink",
    inheritAttrs: false,
    props: {
        to: {
            type: Object,
            required: true,
        },
        linkClass: {
            type: [String, Object, Array],
            default: null,
        },
        textClass: {
            type: [String, Object, Array],
            default: null,
        },
    },
    computed: {
        linkEnabled() {
            const routeName = this.to?.name;
            if (!routeName) {
                return false;
            }
            return canAccessNavigationRoute(routeName);
        },
        boundAttrs() {
            const { class: _class, ...rest } = this.$attrs;
            return rest;
        },
        resolvedLinkClass() {
            return [this.linkClass, this.$attrs.class].filter(Boolean);
        },
        resolvedTextClass() {
            return [this.textClass, this.$attrs.class].filter(Boolean);
        },
    },
};
</script>
